<template>
  <div id="container">
    <h2 id="title">THIS MAP IS AN ALERT</h2>
    <p class="description">
      We want to highlight the <b>scale of the crisis</b> that
      American business, and hence our country, is facing.
    </p>
    <hr>
    <p class="description">
      If <b>your business</b> is suffering, or in danger, share your
      story. We must show that we need help now to survive
      and recover post-pandemic.
    </p>
    <div id="button-container">
      <img src="../assets/add-business-marker.png">
      <button v-on:click="buttonClicked">ADD YOUR BUSINESS</button>
    </div>
  </div>
</template>

<script>
  import {analytics} from '../main.js'

  export default {
    name: "MapHeader",
    methods: {
      buttonClicked() {
        analytics.logEvent('add_business_clicked')
        this.$emit('showModal')
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  #container {
    padding-top: 40px;
    padding-bottom: 40px;
    background: white;
    max-width: 1216px;
    margin: 0 auto;
  }
  #title {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 2.8vw;
    display: inline;
    color: black;
  }
  .description {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 1.4vw;
    text-align: center;
    margin: 20px auto 0 auto;
    width: 42%;
  }
  hr {
    margin-top: 20px;
    width: 8%;
    border: none;
    background-color: #DDDDDD;
    height: 1px;
  }
  #button-container {
    position: relative;
    margin: 35px auto 0 auto;
    width: 32%;
  }
  button {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    background-color: #232A2E;
    border: none;
    border-radius: 4px;
    color: white;
    width: 100%;
    padding: 12px 0;
    text-align: center;
    text-decoration: none;
    font-size: 1.5vw;
    cursor: pointer;
  }
  button:hover {
    opacity: 0.95;
  }
  img {
    position: absolute;
    left: 12px;
    top: -25px;
    height: 35px;
    z-index: 1;
  }

  /*LARGE DESKTOPS*/
  @media only screen and (min-width: 1440px) {
    #title {
      font-size: 40px;
    }
    .description {
      font-size: 20px;
    }
    button {
      font-size: 22px;
    }
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #container {
      padding-top: 30px;
      padding-bottom: 30px;
    }
    #title {
      font-size: 5.9vw;
    }
    .description {
      font-size: 13px;
      width: 90%;
    }
    hr {
      width: 20%;
    }
    #button-container {
      width: 65%;
    }
    button {
      font-size: 3.5vw;
    }
  }
</style>